import { Component, OnInit, OnDestroy } from '@angular/core';
import {Location} from '@angular/common';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import {ServiceService} from './service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import {SlimLoadingBarService} from 'ng2-slim-loading-bar';
import { MetaService } from 'ng2-meta';
interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  image:string;
  service_title:string;
  
  
}
@Component({
	//template: require('./newsdetail.component.html')
	templateUrl: './pg/service/servicedetail.component.html'
})

export class ServiceDetailComponent implements OnInit {
	
	
	pagedata: PageData;
	public serviceData;
	private _sub: Subscription;
	public metatitle;
    public metadescription;
    
    public category; 
    public news:Array<any>;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private slimLoadingBarService: SlimLoadingBarService,
	    private metaService: MetaService,
	    private _location:Location,
	    private _pageService: ServiceService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: '',
                  service_title:'',
                  image:''
                 
				  	}		  
	    }
	    

	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh naga";
	      window.scrollTo(0, 0);
	   this.slimLoadingBarService.start(); 
	  this._sub = this._route.params.subscribe(params => {
			let slug =params['slug'];
			this.category=slug;
						 //  console.log(slug);
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);	
			   		   
			   this._pageService.getServicedetail(slug).subscribe(
        data => {
        
                 //                 
                  this.pagedata.title=data.menu.link_showing_name;
                             
                  if(data.service_detail.meta_title)
                  {
	                   this._title.setTitle(data.service_detail.meta_title);
	                   this.metaService.setTag('og:title',data.service_detail.meta_title); 
                  }                 
                  else
                  {
	                  this._title.setTitle(data.service_detail.service_title);
	                  this.metaService.setTag('og:title',data.service_detail.service_title); 
                  }
                  
                  this.metaService.setTag('description',data.service_detail.meta_description);                   
                  this.metaService.setTag('keywords',data.service_detail.meta_keywords);  
                  // console.log(data.data.news_detail);                
                  this.pagedata.service_title=data.service_detail.service_title;  
                  this.pagedata.description=data.service_detail.service_description;  
                  this.pagedata.image=data.service_detail.image;  
                  this.slimLoadingBarService.complete();   
                               
                  //$window.document.title ='someTitleYouCreated' ;
                  //console.log(this.pagedata.title);              
        },
        err => console.error(err)
        
    );
			   
			   
			   
			   
			   
			   		   
		});
		
	
		
	}

    ngOnDestroy() {
       this._sub.unsubscribe();
    }
    
    backClicked() {
    
        this._location.back();
    }


}


// WEBPACK FOOTER //
// ./resources/assets/typescript/service/servicedetail.component.ts